<template>
	<div class="form_item">
		<div class="form_item_label" v-if="label">
			<span>{{ label }}</span>
		</div>
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'FormItem',
		props: {
			label: {
				type: String,
				default: ''
			}
		}

	}
</script>

<style scoped lang="less">
	.form_item {
		.form_item_label {
			font-family: PingFangSC-Medium;
			padding: 38px 0;
			height: 45px;
			line-height: 45px;
			font-size: 32px;
			font-weight: 500;
			color: #1F2329;
		}
	}
</style>
